<template>
  <div>
    <div class="row">
      <div
        v-if="!visaoSimplificada"
        class="col-xs-4 col-sm-4 col-md-4 col-lg-4"
      >
        <div
          :class="{
            'has-error':
              validations.guia.contratadoSolicitante.documentoSolicitante
                .$error,
          }"
          class="form-group"
        >
          <label for="documentoSolicitante"
            >13 - Código na operadora / CNPJ / CPF <sup>(1)</sup></label
          >
          <div class="input-group">
            <div class="input-group-addon">
              <span
                type="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >{{ nomeDocumentoSolicitante }} <span class="caret"
              /></span>
              <ul class="dropdown-menu">
                <li
                  :class="{
                    active: guia.contratadoSolicitante.tipoSolicitante === 'C',
                  }"
                >
                  <a
                    data-test-id="a-alterartipo-1"
                    href="#"
                    @click.prevent="alterarTipo('C')"
                    >Cód. na operadora</a
                  >
                </li>
                <li
                  :class="{
                    active: guia.contratadoSolicitante.tipoSolicitante === 'F',
                  }"
                >
                  <a
                    data-test-id="a-alterartipo-2"
                    href="#"
                    @click.prevent="alterarTipo('F')"
                    >CPF</a
                  >
                </li>
                <li
                  :class="{
                    active: guia.contratadoSolicitante.tipoSolicitante === 'J',
                  }"
                >
                  <a
                    data-test-id="a-alterartipo-3"
                    href="#"
                    @click.prevent="alterarTipo('J')"
                    >CNPJ</a
                  >
                </li>
              </ul>
            </div>
            <input
              v-if="guia.contratadoSolicitante.tipoSolicitante === 'C'"
              id="documentoSolicitante"
              v-model="guia.contratadoSolicitante.documentoSolicitante"
              data-test-id="input-documentosolicitante-codigo"
              type="text"
              name="documentoSolicitante"
              class="form-control"
              placeholder="Código na operadora do contratado solicitante"
              @input="
                validations.guia.contratadoSolicitante.documentoSolicitante.$touch()
              "
            />
            <input
              v-if="guia.contratadoSolicitante.tipoSolicitante === 'F'"
              id="documentoSolicitante"
              v-model="guia.contratadoSolicitante.documentoSolicitante"
              v-mask="'999.999.999-99'"
              data-test-id="input-documentosolicitante-cpf"
              type="text"
              name="documentoSolicitante"
              class="form-control"
              placeholder="CPF do contratado solicitante"
              @input="
                validations.guia.contratadoSolicitante.documentoSolicitante.$touch()
              "
            />
            <input
              v-if="guia.contratadoSolicitante.tipoSolicitante === 'J'"
              id="documentoSolicitante"
              v-model="guia.contratadoSolicitante.documentoSolicitante"
              v-mask="'99.999.999/9999-99'"
              data-test-id="input-documentosolicitante-cnpj"
              type="text"
              name="documentoSolicitante"
              class="form-control"
              placeholder="CNPJ do contratado solicitante"
              @input="
                validations.guia.contratadoSolicitante.documentoSolicitante.$touch()
              "
            />
          </div>
          <span
            v-if="
              validations.guia.contratadoSolicitante.documentoSolicitante.$dirty
            "
          >
            <span
              v-if="
                !validations.guia.contratadoSolicitante.documentoSolicitante
                  .required
              "
              class="help-block"
              >Campo obrigatório.</span
            >
          </span>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-8 col-sm-8 col-md-8 col-lg-8"
      >
        <div
          :class="{
            'has-error': validations.guia.contratadoSolicitante.nome.$error,
          }"
          class="form-group"
        >
          <label for="nome">14 - Nome do contratado <sup>(1)</sup></label>
          <input
            id="nome"
            v-model="guia.contratadoSolicitante.nome"
            data-test-id="input-nome"
            type="text"
            name="nome"
            class="form-control"
            placeholder="Nome do contratado"
            @input="validations.guia.contratadoSolicitante.nome.$touch()"
          />
          <span v-if="validations.guia.contratadoSolicitante.nome.$dirty">
            <span
              v-if="!validations.guia.contratadoSolicitante.nome.required"
              class="help-block"
              >Campo obrigatório.</span
            >
            <span
              v-if="!validations.guia.contratadoSolicitante.nome.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.contratadoSolicitante.nome.$params.maxLength
                  .max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-4 col-sm-4 col-md-4 col-lg-4"
      >
        <div
          :class="{
            'has-error': validations.guia.contratadoSolicitante.cnes.$error,
          }"
          class="form-group"
        >
          <label for="cnes">15 - Código CNES</label>
          <input
            id="cnes"
            v-model="guia.contratadoSolicitante.cnes"
            data-test-id="input-cnes"
            type="text"
            name="cnes"
            class="form-control"
            placeholder="Código CNES do contratado solicitante"
            @input="validations.guia.contratadoSolicitante.cnes.$touch()"
          />
          <span v-if="validations.guia.contratadoSolicitante.cnes.$dirty">
            <span
              v-if="!validations.guia.contratadoSolicitante.cnes.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.contratadoSolicitante.cnes.$params.maxLength
                  .max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
        <div
          :class="{
            'has-error':
              validations.guia.contratadoSolicitante.profissionalSolicitante
                .nome.$error,
          }"
          class="form-group"
        >
          <label for="conselho"
            >16 - Nome do profissional solicitante <sup>(2)</sup></label
          >
          <BuscarSelecionar
            :lista="solicitantes"
            :selecionado="guia.contratadoSolicitante.profissionalSolicitante"
            :minimo="1"
            :classes-input="
              visaoSimplificada ? 'form-control input-sm' : 'form-control'
            "
            @selecionar="selecionarSolicitante"
            @limpar="limparSolicitante"
            @recuperar="recuperarSolicitante"
          />
          <span
            v-if="
              validations.guia.contratadoSolicitante.profissionalSolicitante
                .nome.$dirty
            "
          >
            <span
              v-if="
                !validations.guia.contratadoSolicitante.profissionalSolicitante
                  .nome.required
              "
              class="help-block"
              >Campo obrigatório.</span
            >
            <span
              v-if="
                !validations.guia.contratadoSolicitante.profissionalSolicitante
                  .nome.maxLength
              "
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.contratadoSolicitante.profissionalSolicitante
                  .nome.$params.maxLength.max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-3 col-sm-3 col-md-3 col-lg-3"
      >
        <div
          :class="{
            'has-error':
              validations.guia.contratadoSolicitante.profissionalSolicitante
                .conselho.$error,
          }"
          class="form-group"
        >
          <label for="conselho"
            >17 - Conselho profissional <sup>(1)</sup></label
          >
          <select
            id="conselho"
            v-model="
              guia.contratadoSolicitante.profissionalSolicitante.conselho
            "
            data-test-id="select-conselho"
            name="conselho"
            class="form-control"
          >
            <option disabled value="">Selecione</option>
            <option
              v-for="conselho in conselhos"
              :key="conselho.codigo"
              :value="conselho.codigo"
              >{{ conselho.codigo }} - {{ conselho.valor }}</option
            >
          </select>
          <span
            v-if="
              validations.guia.contratadoSolicitante.profissionalSolicitante
                .conselho.$dirty
            "
          >
            <span
              v-if="
                !validations.guia.contratadoSolicitante.profissionalSolicitante
                  .conselho.required
              "
              class="help-block"
              >Campo obrigatório.</span
            >
          </span>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-3 col-sm-3 col-md-3 col-lg-3"
      >
        <div
          :class="{
            'has-error':
              validations.guia.contratadoSolicitante.profissionalSolicitante
                .numeroConselho.$error,
          }"
          class="form-group"
        >
          <label for="numeroConselho"
            >18 - Número no conselho <sup>(1)</sup></label
          >
          <input
            id="numeroConselho"
            v-model="
              guia.contratadoSolicitante.profissionalSolicitante.numeroConselho
            "
            data-test-id="input-numeroconselho"
            type="text"
            name="numeroConselho"
            class="form-control"
            placeholder="Número no conselho profissional"
            @input="
              validations.guia.contratadoSolicitante.profissionalSolicitante.numeroConselho.$touch()
            "
          />
          <span
            v-if="
              validations.guia.contratadoSolicitante.profissionalSolicitante
                .numeroConselho.$dirty
            "
          >
            <span
              v-if="
                !validations.guia.contratadoSolicitante.profissionalSolicitante
                  .numeroConselho.required
              "
              class="help-block"
              >Campo obrigatório.</span
            >
            <span
              v-if="
                !validations.guia.contratadoSolicitante.profissionalSolicitante
                  .numeroConselho.maxLength
              "
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.contratadoSolicitante.numeroConselho.$params
                  .maxLength.max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-3 col-sm-3 col-md-3 col-lg-3"
      >
        <div
          :class="{
            'has-error':
              validations.guia.contratadoSolicitante.profissionalSolicitante
                .ufConselho.$error,
          }"
          class="form-group"
        >
          <label for="conselhoUF">19 - UF conselho <sup>(1)</sup></label>
          <select
            id="conselhoUF"
            v-model="
              guia.contratadoSolicitante.profissionalSolicitante.ufConselho
            "
            data-test-id="select-conselhouf"
            name="conselhoUF"
            class="form-control"
          >
            <option disabled value="">Selecione</option>
            <option v-for="uf in ufs" :key="uf.sigla" :value="uf.sigla">{{
              uf.sigla
            }}</option>
          </select>
          <span
            v-if="
              validations.guia.contratadoSolicitante.profissionalSolicitante
                .ufConselho.$dirty
            "
          >
            <span
              v-if="
                !validations.guia.contratadoSolicitante.profissionalSolicitante
                  .ufConselho.required
              "
              class="help-block"
              >Campo obrigatório.</span
            >
          </span>
        </div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <div
          :class="{
            'has-error':
              validations.guia.contratadoSolicitante.profissionalSolicitante.cbo
                .$error,
          }"
          class="form-group"
        >
          <label for="cbo">20 - Código CBO-S <sup>(1)</sup></label>
          <select
            id="cbo"
            v-model="guia.contratadoSolicitante.profissionalSolicitante.cbo"
            data-test-id="select-cbo"
            :class="{ 'input-sm': visaoSimplificada }"
            name="cbo"
            class="form-control"
          >
            <option disabled value="">Selecione</option>
            <option v-for="cbo in cbos" :key="cbo.codigo" :value="cbo"
              >{{ cbo.codigo }} - {{ cbo.valor }}</option
            >
          </select>
          <span
            v-if="
              validations.guia.contratadoSolicitante.profissionalSolicitante.cbo
                .$dirty
            "
          >
            <span
              v-if="
                !validations.guia.contratadoSolicitante.profissionalSolicitante
                  .cbo.required
              "
              class="help-block"
              >Campo obrigatório.</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'

import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import { dominioMixin } from '@/mixins/DominioMixin'
import EstadoServico from '@/servicos/EstadoServico'
import MedicoServico from '@/servicos/MedicoServico'

const medicoServico = new MedicoServico()
const estadoServico = new EstadoServico()

export default {
  name: 'DadosContratadoSolicitante',
  components: { BuscarSelecionar },
  directives: { mask: AwesomeMask },
  mixins: [dominioMixin],
  props: {
    guia: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      conselhos: [],
      ufs: [],
      cbos: [],
      solicitantes: [],
    }
  },
  computed: {
    nomeDocumentoSolicitante() {
      const tipo = this.guia.contratadoSolicitante.tipoSolicitante

      if (tipo === 'F') {
        return 'CPF'
      } else if (tipo === 'J') {
        return 'CNPJ'
      } else if (tipo === 'C') {
        return 'Cód. na operadora'
      }

      return tipo
    },
  },
  mounted() {
    this.recuperarValoresDominio('cbo').then((res) => {
      this.cbos = res.valores
    })
    this.recuperarValoresDominio('ConselhoProfissional').then((res) => {
      this.conselhos = res.valores
    })
    estadoServico.recuperarUfs().then((res) => {
      this.ufs = res.estados
    })
  },
  methods: {
    recuperarSolicitante(filtro) {
      const codigo = new RegExp('^[0-9]+$').test(filtro.palavra)
        ? filtro.palavra
        : ''
      const nome = new RegExp('^[a-z ]+$', 'i').test(filtro.palavra)
        ? filtro.palavra
        : ''
      medicoServico
        .recuperarTodos({
          nome: nome,
          codigo: codigo,
          ativo: true,
          skip: (filtro.pagina - 1) * filtro.limite,
          limit: filtro.limite,
          orderBy: filtro.chave,
        })
        .then((result) => {
          this.solicitantes = result.medicos
        })
    },
    limparSolicitante() {
      this.guia.contratadoSolicitante.profissionalSolicitante.cbo = {}
      this.guia.contratadoSolicitante.profissionalSolicitante.conselho = ''
      this.guia.contratadoSolicitante.profissionalSolicitante._id = ''
      this.guia.contratadoSolicitante.profissionalSolicitante.nome = ''
      this.guia.contratadoSolicitante.profissionalSolicitante.numeroConselho =
        ''
      this.guia.contratadoSolicitante.profissionalSolicitante.ufConselho = ''
    },
    selecionarSolicitante(medico) {
      this.guia.contratadoSolicitante.profissionalSolicitante = medico
    },
    alterarTipo(tipo) {
      this.guia.contratadoSolicitante.tipoSolicitante = tipo
      this.guia.contratadoSolicitante.documentoSolicitante = ''
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
  },
}
</script>
